import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c8fe98b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8fe98b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8fe98b')) {
      api.createRecord('3c8fe98b', component.options)
    } else {
      api.reload('3c8fe98b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c8fe98b&scoped=true&", function () {
      api.rerender('3c8fe98b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/article/anLi/index.vue"
export default component.exports